import { Box, fontWeight, styled } from "@mui/system";

export const PageTitleStyles = styled(Box)(({ theme }) => ({
  "& .LabelIconBox": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  "& .IconBox": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0.5),
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: theme.spacing(1),
  },
  "& .icon": {
    color: theme.palette.white.main,
  },
  "& .titleBox": {
    display: "flex",
    flexDirection: "column",
  },
  "& .titleText": {
    fontWeight: "550",
  },
}));
